import { useMemo } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const STAR_SIGNS = [
  { name: 'Aries', symbol: '♈' },
  { name: 'Taurus', symbol: '♉' },
  { name: 'Gemini', symbol: '♊' },
  { name: 'Cancer', symbol: '♋' },
  { name: 'Leo', symbol: '♌' },
  { name: 'Virgo', symbol: '♍' },
  { name: 'Libra', symbol: '♎' },
  { name: 'Scorpio', symbol: '♏' },
  { name: 'Sagittarius', symbol: '♐' },
  { name: 'Capricorn', symbol: '♑' },
  { name: 'Aquarius', symbol: '♒' },
  { name: 'Pisces', symbol: '♓' }
];

const HOUSES = [
  { name: 'Gryffindor', symbol: '🦁' },
  { name: 'Hufflepuff', symbol: '🦡' },
  { name: 'Ravenclaw', symbol: '🦅' },
  { name: 'Slytherin', symbol: '🐍' }
];

const MoneyPersonalityBox = () => {
  const personality = useMemo(() => {
    const age = Math.floor(Math.random() * (80 - 18 + 1)) + 18;
    const starSign = STAR_SIGNS[Math.floor(Math.random() * STAR_SIGNS.length)];
    const house = HOUSES[Math.floor(Math.random() * HOUSES.length)];

    return { age, starSign, house };
  }, []);

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -20 }}
        transition={{ duration: 0.3 }}
        className="bg-white rounded-xl p-4 border-2 border-[#221A51] shadow-[4px_4px_0px_0px_#221A51]"
      >
        <div className="text-[#221A51]/60 text-sm mb-3">Money Personality</div>
        <div className="text-[#221A51]">
          <p className="text-lg">
            You spend like a {personality.age} year old {personality.starSign.name} {personality.starSign.symbol} from {personality.house.name} {personality.house.symbol}
          </p>
        </div>
      </motion.div>
    </AnimatePresence>
  );
};

export default MoneyPersonalityBox;
